import React from "react";
import kreemjas from '../../assets/kreemjas.jpeg'; // Tell webpack this JS file uses this image
import metsaoite from '../../assets/metsaoite.jpeg'; // Tell webpack this JS file uses this image
import { NavLink } from "react-router-dom";


import "./Home.css";

export const Home = () => {
  return <div className="home">
    <div className="temp">
        <p>Hetkel kahjuks veebipoest asju osta veel ei saa, tellimiseks palun <NavLink to="/kontakt">võtke meiega ühendust!</NavLink></p> 
    </div>
    <div className="products">
        <div className="product">
            <img src={metsaoite} alt="Logo" className="productImage"/>
            <p className="name">Metsaõite Mesi 500g</p>
            <p className="price">5€</p>
        </div>
        <div className="product">
            <img src={kreemjas} alt="Logo" className="productImage"/>
            <p className="name">Kreemjas Mesi 500g</p>
            <p className="price">5€</p>
        </div>
    </div>
  </div>
};